import React, { useEffect, useState } from "react";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const TermsAndConditions = () => {
  const aboutUs = `${API_BASE_URL}/static/terms-condition`;
  console.log(process.env.REACT_APP_API_BASE_URL)

  const [termData, setTermData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await fetch(aboutUs);
      const data = await response.json();
      setTermData(data?.data[0]);
      
      console.log(data?.data[0]);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      {termData ? (
        <div className="bg-white shadow-md rounded-lg p-6 max-w-5xl w-full text-justify">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-gray-800">
            {termData?.heading}
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4">
          {termData?.paragraph_1}
          </p>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4">
          {termData?.paragraph_2}
          </p>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4">
          {termData?.paragraph_3}
          </p>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4">
          {termData?.paragraph_4}
          </p>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-4">
          {termData?.paragraph_5}
          </p>

          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {termData?.sub_heading_1}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {termData?.paragraph_6}
          </p>

          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {termData?.sub_heading_2}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {termData?.paragraph_7}
          </p>

          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {termData?.sub_heading_3}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {termData?.paragraph_8}
          </p>

          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {termData?.sub_heading_4}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {termData?.paragraph_9}
          </p>

          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {termData?.sub_heading_5}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {termData?.paragraph_10}
          </p>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {termData?.paragraph_11}
          </p>

          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mt-4 mb-2 text-gray-800">
          {termData?.sub_heading_6}
          </h2>
          <p className="text-base sm:text-lg md:text-2xl text-gray-700 mb-4">
          {termData?.paragraph_12}
          </p>

          
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default TermsAndConditions;
